/**
 * Markdown Component Configuration
 *
 * Custom React components for rendering Markdown elements with TailwindCSS styling.
 * Used with ReactMarkdown for consistent, styled markdown rendering.
 */

import React from 'react';

/**
 * Custom component overrides for ReactMarkdown
 * Provides styled table rendering with responsive overflow handling
 */
export const markdownComponents = {
  table: ({ children, ...props }) => (
    <div className="overflow-x-auto my-4 -mx-4 px-2" style={{ maxWidth: 'calc(100vw - 4.5rem)' }}>
      <table className="w-full border-collapse" {...props}>
        {children}
      </table>
    </div>
  ),
  thead: ({ children, ...props }) => (
    <thead className="bg-gray-800/50 border-b border-gray-700" {...props}>
      {children}
    </thead>
  ),
  tbody: ({ children, ...props }) => (
    <tbody className="divide-y divide-gray-700/30" {...props}>
      {children}
    </tbody>
  ),
  tr: ({ children, ...props }) => (
    <tr className="hover:bg-gray-800/30 transition-colors" {...props}>
      {children}
    </tr>
  ),
  th: ({ children, ...props }) => (
    <th className="px-4 py-2 text-left text-sm font-medium text-emerald-400 uppercase tracking-wider" {...props}>
      {children}
    </th>
  ),
  td: ({ children, ...props }) => (
    <td className="px-2 sm:px-4 py-2 text-sm text-gray-200 break-words" {...props}>
      {children}
    </td>
  )
};
